var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"background"},[_c('NavBar'),_c('v-main',{staticClass:"mt-4"},[_c('router-view',{staticClass:"pb-4"})],1),_c('LoadingOverlay'),_c('DialogOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }